export enum ContainerSizesEnum {
  SMALL = 'sm',
  MEDIUM = 'md',
}
